/**
 * College Bronze — intercept Cart Checkout → /pages/gameday-addons
 * Skips when session already completed the step, or cart already has Frost Buddy.
 */
(function () {
  var ADDONS_PATH = '/pages/gameday-addons';
  var SESSION_KEY = 'cb_gameday_addons_done';
  var checking = false;

  function alreadyDone() {
    try {
      return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function onAddonsPage() {
    return window.location.pathname.indexOf('/pages/gameday-addons') === 0;
  }

  function cartHasFrostBuddy(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;
    return cart.items.some(function (item) {
      return String(item.vendor || '').toLowerCase() === 'frost buddy';
    });
  }

  function fetchCart() {
    var root =
      (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    });
  }

  function go(url) {
    window.location.href = url;
  }

  function intercept(event) {
    if (alreadyDone() || onAddonsPage()) return;
    if (checking) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    checking = true;

    fetchCart()
      .then(function (cart) {
        if (!cart.item_count) {
          go('/cart');
          return;
        }
        if (cartHasFrostBuddy(cart)) {
          try {
            sessionStorage.setItem(SESSION_KEY, '1');
          } catch (e) {}
          go('/checkout');
          return;
        }
        go(ADDONS_PATH);
      })
      .catch(function () {
        // Fail open to normal checkout if cart.js is unavailable
        go('/checkout');
      })
      .finally(function () {
        checking = false;
      });
  }

  function isCheckoutControl(el) {
    if (!el || !el.closest) return null;
    var btn = el.closest(
      '#CartDrawer-Checkout, #checkout, button[name="checkout"], input[name="checkout"], .cart__checkout-button'
    );
    return btn || null;
  }

  document.addEventListener(
    'click',
    function (event) {
      var btn = isCheckoutControl(event.target);
      if (!btn) return;
      if (btn.disabled) return;
      intercept(event);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form) return;
      // Cart drawer + cart page forms that submit checkout
      var id = form.id || '';
      if (id !== 'CartDrawer-Form' && id !== 'cart') return;
      // Only intercept when the submitter is checkout (not update)
      var submitter = event.submitter;
      if (submitter && submitter.name && submitter.name !== 'checkout') return;
      if (alreadyDone() || onAddonsPage()) return;
      intercept(event);
    },
    true
  );
})();
